import { useEffect } from 'react';
import { useVisualizer as useVisualizerContext } from '../context/AppContext.jsx';
import { Visualizer3D } from '../visualizer/Visualizer3D.js';

export function useVisualizer() {
  const { visualizer, setVisualizer } = useVisualizerContext();
  
  useEffect(() => {
    const container = document.getElementById('viewer');
    if (!container || visualizer) {
      return;
    }
    
    try {
      const viz = new Visualizer3D(container);
      
      // Setup callbacks
      viz.onWaypointClick = (waypoint, index) => {
        const event = new CustomEvent('waypointSelected', { detail: { index } });
        document.dispatchEvent(event);
      };
      
      viz.onViaPointClick = (waypointIndex, userData) => {
        const event = new CustomEvent('viaPointSelected', { detail: { waypointIndex } });
        document.dispatchEvent(event);
      };

      viz.onFeatureClick = (index) => {
        const event = new CustomEvent('featureSelected', { detail: { index } });
        document.dispatchEvent(event);
      };

      viz.onDeselect = () => {
        const event = new CustomEvent('waypointDeselected');
        document.dispatchEvent(event);
      };
      
      // Expose visualizer to window for debugging
      window.visualizer = viz;
      
      setVisualizer(viz);
    } catch (error) {
      console.error('Error initializing visualizer:', error);
    }
    
    return () => {
      if (visualizer && visualizer.dispose) {
        visualizer.dispose();
      }
    };
  }, [visualizer, setVisualizer]);
}

